// extracted by mini-css-extract-plugin
export default {"button":"CDKe8","downloadIcon":"cu9dS"};